/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoDrawItemListDrawItemInfoData model module.
 * @module model/EventsControllerDtoDrawItemListDrawItemInfoData
 * @version 1.0
 */
class EventsControllerDtoDrawItemListDrawItemInfoData {
    /**
     * Constructs a new <code>EventsControllerDtoDrawItemListDrawItemInfoData</code>.
     * @alias module:model/EventsControllerDtoDrawItemListDrawItemInfoData
     */
    constructor() { 
        
        EventsControllerDtoDrawItemListDrawItemInfoData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoDrawItemListDrawItemInfoData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoDrawItemListDrawItemInfoData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoDrawItemListDrawItemInfoData} The populated <code>EventsControllerDtoDrawItemListDrawItemInfoData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoDrawItemListDrawItemInfoData();

            if (data.hasOwnProperty('drawItemNo')) {
                obj['drawItemNo'] = ApiClient.convertToType(data['drawItemNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('perPrice')) {
                obj['perPrice'] = ApiClient.convertToType(data['perPrice'], 'Number');
            }
            if (data.hasOwnProperty('xperPrice')) {
                obj['xperPrice'] = ApiClient.convertToType(data['xperPrice'], 'Number');
            }
            if (data.hasOwnProperty('purchaseLimit')) {
                obj['purchaseLimit'] = ApiClient.convertToType(data['purchaseLimit'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('userCount')) {
                obj['userCount'] = ApiClient.convertToType(data['userCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoDrawItemListDrawItemInfoData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoDrawItemListDrawItemInfoData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {Number} drawItemNo
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['drawItemNo'] = undefined;

/**
 * @member {String} title
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['title'] = undefined;

/**
 * @member {Number} perPrice
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['perPrice'] = undefined;

/**
 * @member {Number} xperPrice
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['xperPrice'] = undefined;

/**
 * @member {Number} purchaseLimit
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['purchaseLimit'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['createdAt'] = undefined;

/**
 * @member {Number} userCount
 */
EventsControllerDtoDrawItemListDrawItemInfoData.prototype['userCount'] = undefined;






export default EventsControllerDtoDrawItemListDrawItemInfoData;

